module.exports = __webpack_public_path__ + "static/img/3.9397225.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/10/zh/3.png
// module id = 4l29
// module chunks = 0